var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTagInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.7 71.5H58.3V51.7H51.7V71.5ZM55 22C36.784 22 22 36.784 22 55C22 73.216 36.784 88 55 88C73.216 88 88 73.216 88 55C88 36.784 73.216 22 55 22ZM55 81.4C40.447 81.4 28.6 69.553 28.6 55C28.6 40.447 40.447 28.6 55 28.6C69.553 28.6 81.4 40.447 81.4 55C81.4 69.553 69.553 81.4 55 81.4ZM51.7 45.1H58.3V38.5H51.7V45.1Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTagInfo);
export default __webpack_public_path__ + "static/media/icon-tag-info.dbe05c2802cae453bfc8d2f621cd48f2.svg";
export { ForwardRef as ReactComponent };